import {
  Avatar,
  Badge,
  Box,
  Card,
  Grid,
  List,
  ListItemButton,
  Paper,
  Radio,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { appSelector } from "../../redux/selector";
import axios from "axios";
import { BusinessCenterRounded, LaunchRounded } from "@mui/icons-material";
import moment from "moment";
import Key from "../../../../src/clientVariables.json";
import { myCandidatesSelector } from "../redux/selector";
import { getCandidateResumeListAction } from "../redux/action";

const ResumesList = ({ selectedResume, candidateResumesList = [] }) => {
  const dispatch = useDispatch();

  const { candidateDetails, submissionSelectedResume } =
    useSelector(myCandidatesSelector);
  const [selectedResume1, setSelectedResume1] = useState(null);

  const theme = useTheme();
  const isDesktopLarge = useMediaQuery(theme.breakpoints.up("lg")); // Large desktops

  useEffect(() => {
    if (candidateResumesList && candidateResumesList?.length > 0) {
      const primaryResume = candidateResumesList.find(
        (resume) => resume.isPrimary === 1
      );
      const selectedFile = primaryResume || candidateResumesList?.[0];
      setSelectedResume1(selectedFile);
      selectedResume(selectedFile);
    }
  }, [candidateResumesList]);

  const controlProps = (item) => ({
    checked: selectedResume1
      ? selectedResume1.resume_id === item.resume_id
      : submissionSelectedResume.resume_id === item.resume_id,
    onChange: () => handleFileChange(item),
    value: item.resume_id,
    name: "size-radio-button-demo",
    inputProps: { "aria-label": item.resume_id },
  });

  const handleFileChange = (item) => {
    setSelectedResume1(item);
    selectedResume(item);
  };

  const paperStyles = {
    borderRadius: "8px",
    height: "100vh",
    //  overflow:"auto"
  };

  return (
    <Grid container spacing={2}>
      {(candidateResumesList || []).map((resume, index) => (
        <Grid item sm={12} key={index}>
          <Card
            sx={{
              boxShadow: "none",
              borderRadius: "8px",
              border: "1px solid #ddd",
              position: "relative", // Ensure relative positioning for absolute badge
            }}
          >
            <Grid container>
              {/* <Badge
                  color="primary"
                  badgeContent="Primary Resume0000"
                  invisible={resume?.isPrimary != 1} // Show only if primary
                  sx={{
                    "& .MuiBadge-badge": {
                      left: 315,
                      top: 5,
                      backgroundColor: "#406882",
                      color: "#fff",
                      fontSize: "0.65rem",
                      height: "20px",
                      borderRadius: "4px",
                      padding: "0 4px",
                      marginTop: "5px",
                      width: "100px",
                      textTransform: "uppercase",
                    },
                  }}
                ></Badge> */}

              <Badge
                color="primary"
                badgeContent="Primary Resume"
                invisible={resume?.isPrimary !== 1} // Show only if primary
                sx={{
                  position: "absolute", // Position the badge absolutely
                  top: 8, // Adjust top distance
                  right: 49, // Place it to the right
                  "& .MuiBadge-badge": {
                    backgroundColor: "#406882",
                    color: "#fff",
                    fontSize: "0.7rem",
                    height: "auto",
                    padding: "2px 6px",
                    borderRadius: "4px",
                    whiteSpace: "nowrap",
                  },
                }}
              />
              <Grid
                item
                xs={2}
                sx={{
                  bgcolor: resume.filetype === "pdf" ? "#d32f2f" : "#1976d2",
                  color: "#fff",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {resume.filetype === "pdf" ? "PDF" : "Docs"}
              </Grid>
              <Grid item xs={8} sx={{ p: 2 }}>
                <Typography
                  paragraph
                  sx={{
                    mb: 0,
                    fontWeight: 500,
                    fontSize: "14px",
                    minWidth: isDesktopLarge ? "150px" : "110px",
                    maxWidth: isDesktopLarge ? "150px" : "110px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {resume.filename?.replace(/^cand_(cand_)?/i, "")}
                </Typography>
                <Typography
                  paragraph
                  sx={{ mb: 0, fontSize: "12px", color: "#757575" }}
                >
                  {resume.created !== undefined && resume.created !== null
                    ? moment(resume.created).fromNow() !== "Invalid date"
                      ? moment(resume.created).fromNow()
                      : moment("2022-03-31T06:26:04.138Z").fromNow()
                    : moment("2022-03-31T06:26:04.138Z").fromNow()}
                </Typography>
              </Grid>
              <Grid
                item
                xs={2}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {/* <Radio
                    {...controlProps(resume)}
                    sx={{
                      "& .MuiSvgIcon-root": {
                        fontSize: 24,
                      },
                    }}
                  /> */}
              </Grid>
            </Grid>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default ResumesList;
